import * as React from 'react'
import { Tooltip, Icon } from 'antd'

interface Props {
  canSave: boolean
  editable: boolean
  isUpdating: boolean
  hasNoChangeInValue?: boolean
  onSave: VoidFunction
  onEdit: VoidFunction
  onCancel: VoidFunction
}

export const ButtonGroup = (props: Props) => {
  const { canSave, editable, isUpdating, hasNoChangeInValue, onSave, onEdit, onCancel } = props

  const ICON_SIZE = 18

  if (!editable) {
    return (
      <span className='d-flex'>
        <Tooltip title='Edit' className='cursor-pointer'>
          <Icon
            style={{ fontSize: ICON_SIZE }}
            type='edit'
            className='text-primary'
            onClick={onEdit}
          />
        </Tooltip>
      </span>
    )
  }

  return (
    <span className='d-flex'>
      {hasNoChangeInValue ? (
        <Icon
          style={{ fontSize: ICON_SIZE }}
          type='check-circle'
          className={`pr-1 ${isUpdating ? 'text-success' : 'disabled'}`}
        />
      ) : (
        <Tooltip
          title={canSave ? (isUpdating ? 'Updating' : 'Save') : 'Invalid value'}
          placement='topLeft'
          className='cursor-pointer'
        >
          {canSave ? (
            <Icon
              style={{ fontSize: ICON_SIZE }}
              type={isUpdating ? 'loading' : 'check-circle'}
              className='pr-1 text-success'
              onClick={onSave}
            />
          ) : (
            <Icon
              style={{ fontSize: ICON_SIZE }}
              type={isUpdating ? 'loading' : 'exclamation-circle'}
              className='pr-1'
            />
          )}
        </Tooltip>
      )}

      <Tooltip title='Cancel' className='cursor-pointer'>
        <Icon
          style={{ fontSize: ICON_SIZE }}
          type='close-circle'
          className='pl-1 text-danger'
          onClick={onCancel}
        />
      </Tooltip>
    </span>
  )
}
